module.exports = __webpack_public_path__ + "img/31.62e0a8f4.jpg";